<template>    
<fieldset>
    <div v-if="index === 0">
        <div class="text"></div>
        <div>
            <label class="required">
                Direction
            </label>
        </div>
        <div>
            <label class="required">
                Pipe Size
            </label>
        </div>
        <div>
            <label class="required">
                Pipe Type
            </label>
        </div>
        <div class="text">
            <label class="required">
                Pipe Length
            </label>
        </div>
        <div class="text">
            <label class="required">
                Pipe Weight
            </label>
        </div>
        <div class="text">
            <label class="required">
                Total Pipe Wt
            </label>
        </div>
        <div class="row-edit"></div>
    </div>
    <!-- Begin Lateral -->
    <div v-if="displayFirst == 'lateral'">
        <div class="text">
            <label v-text="name"></label>
        </div>
        <div class="text">
            <label>Lateral</label>
        </div>
        <div>
            <div class="select">
                <select @input="setName">
                    <option value="" v-text="loadingText" />
                    <option v-for="option in lateralPipes" 
                        :value="option.name" 
                        v-text="option.name" 
                        :disabled="option.disabled" 
                        :selected="option.name == localData.pipeName" />
                </select>
            </div>
        </div>
        <div>
            <div class="select">
                <select @input="setType">
                    <option value="" v-text="loadingText"></option>
                    <option v-for="option in types" 
                        :value="option.type"
                        v-text="option.type" 
                        :disabled="option.disabled"
                        :selected="option.type == localData.pipeType" />
                </select>
            </div>
        </div>
        <div class="text">
            <input-number 
                id="lateral-pipe-length"
                v-model="localData.lateralPipeLength" 
                :uid="uid"  
                :mToFt="useMetric(2)"  
                :min="lateralMin" 
                :max="lateralMax" 
                required />
        </div>
        <div class="text">
            <span v-if="lateralWeightPerFoot" v-text="lbPerFootOrKgPerM(lateralWeightPerFoot, true, 2)"></span>
        </div>
        <div class="text">
            <span v-if="lateralWeightPerFoot" v-text="lbOrKg(lateralWeight, true, false, 2)"></span>
        </div>
        <div class="row-edit"></div>
    </div>
    <div v-if="displayFirst == 'lateral'">
        <div class="text">
            <label v-text="name"></label>
        </div>
        <div class="text">
            <label>Longitudinal</label>
        </div>
        <div>
            <div class="select">
                <select @input="setSecondaryName">
                    <option value="" v-text="loadingText" />
                    <option v-for="option in longitudinalPipes" 
                        :value="option.name" 
                        v-text="option.name" 
                        :disabled="option.disabled"
                        :selected="option.name == localData.secondaryPipeName" />
                </select>
            </div>
        </div>
        <div>
            <div class="select">
                <select @input="setSecondaryType">
                    <option value="" v-text="loadingText" />
                    <option v-for="option in filteredTypes" 
                        :value="option.type" 
                        v-text="option.type" 
                        :disabled="option.disabled"
                        :selected="option.type == localData.secondaryPipeType" />
                </select>
            </div>
        </div>
        <div class="text">
            <input-number
                id="longitudinal-pipe-length"
                @input="setSecondaryWeightPerFoot"
                v-model="localData.longitudinalPipeLength" 
                :mToFt="useMetric(2)" 
                :min="longitudinalMin" 
                :max="longitudinalMax" 
                required />
        </div>
        <div class="text">
            <span v-if="longitudinalWeightPerFoot" v-text="lbPerFootOrKgPerM(longitudinalWeightPerFoot, true, 2)"></span>
        </div>
        <div class="text">
            <span v-if="longitudinalWeightPerFoot" v-text="lbOrKg(longitudinalWeight, true, false, 2)"></span>
        </div>
        <div class="row-edit">
            <i v-if="can.delete" class="fa fa-trash" aria-hidden="true" @click="removeSegment"></i>
        </div>
    </div>
    <!-- End Lateral | Begin Longitudinal -->
    <div v-if="displayFirst == 'longitudinal'">
        <div class="text">
            <label v-text="name"></label>
        </div>
        <div class="text">
            <label>Longitudinal</label>
        </div>
        <div>
            <div class="select">
                <select @input="setName">
                    <option value="" v-text="loadingText" />
                    <option v-for="option in longitudinalPipes" 
                        :value="option.name" 
                        v-text="option.name" 
                        :disabled="option.disabled" 
                        :selected="option.name == localData.pipeName" />
                </select>
            </div>
        </div>
        <div>
            <div class="select">
                <select @input="setType">
                    <option value="" v-text="loadingText"></option>
                    <option v-for="option in filteredTypes" 
                        :value="option.type"
                        v-text="option.type" 
                        :disabled="option.disabled"
                        :selected="option.type == localData.pipeType" />
                </select>
            </div>
        </div>
        <div class="text">
            <input-number
                id="longitudinal-pipe-length"
                v-model="localData.longitudinalPipeLength" 
                :mToFt="useMetric(2)" 
                :min="longitudinalMin" 
                :max="longitudinalMax" 
                required />
        </div>
        <div class="text">
            <span v-if="longitudinalWeightPerFoot" v-text="lbPerFootOrKgPerM(longitudinalWeightPerFoot, true, 2)"></span>
        </div>
        <div class="text">
            <span v-if="longitudinalWeightPerFoot" v-text="lbOrKg(longitudinalWeight, true, false, 2)"></span>
        </div>
        <div class="row-edit">
            <i v-if="can.delete" class="fa fa-trash" aria-hidden="true" @click="removeSegment"></i>
        </div>
    </div>
    <div v-if="displayFirst == 'longitudinal'">
        <div class="text">
            <label v-text="name"></label>
        </div>
        <div class="text">
            <label>Lateral</label>
        </div>
        <div>
            <div class="select">
                <select @input="setSecondaryName">
                    <option value="" v-text="loadingText" />
                    <option v-for="option in lateralPipes" 
                        :value="option.name" 
                        v-text="option.name" 
                        :disabled="option.disabled"
                        :selected="option.name == localData.secondaryPipeName" />
                </select>
            </div>
        </div>
        <div>
            <div class="select">
                <select @input="setSecondaryType">
                    <option value="" v-text="loadingText" />
                    <option v-for="option in types" 
                        :value="option.type" 
                        v-text="option.type" 
                        :disabled="option.disabled"
                        :selected="option.type == localData.secondaryPipeType" />
                </select>
            </div>
        </div>
        <div class="text">
            <input-number 
                id="lateral-pipe-length"
                @input="setSecondaryWeightPerFoot"
                v-model="localData.lateralPipeLength" 
                :uid="uid"  
                :mToFt="useMetric(2)"  
                :min="lateralMin" 
                :max="lateralMax" 
                required />
        </div>
        <div class="text">
            <span v-if="lateralWeightPerFoot" v-text="lbPerFootOrKgPerM(lateralWeightPerFoot, true, 2)"></span>
        </div>
        <div class="text">
            <span v-if="lateralWeightPerFoot" v-text="lbOrKg(lateralWeight, true, false, 2)"></span>
        </div>
        <div class="row-edit"></div>
    </div>
    <!-- End Longitudinal -->
    <div v-if="orientationError">
        <div>
            <div class="error" v-text="orientationError"/>
        </div>
    </div>
    <div v-if="pipeNote">
        <div>
            <div class="note" v-text="pipeNote"/>
        </div>
    </div>
</fieldset>
</template>

<script>
import { mapKeyedGetters } from '../../../common/vuex-extra';
import { mapGetters, mapState } from 'vuex';
import Fraction from 'fraction.js';
import InputNumber from 'vue/common/_inputNumber';
import debounce from 'lodash/debounce';

const ALPHA = [
    'a','b','c','d','e','f','g',
    'h','i','j','k','l','m','n',
    'o','p','q','r','s','t','u',
    'v','w','x','y','z'
];

export default {
    name: 'submittal-line-segment',
    components: {
        InputNumber,
    },
    props: [
        'uid',
        'lateralLimit',
        'longitudinalLimit',
        'mainBranch',
    ],
    data() {
        return {
            localData: {}
        };
    },
    mounted() {
        this.localData = Object.assign({}, this.record);
        this.setMainPipeType();
    },
    watch: {
        orientation: {
            handler(newVal, oldVal){
                const latLongs = ['lateral-longitudinal', 'longitudinal-lateral'];

                if (latLongs.includes(newVal) && latLongs.includes(oldVal)) {
                    const temp = {
                        pipeName: this.localData.pipeName,
                        pipeType: this.localData.pipeType,
                        secondaryPipeName: this.localData.secondaryPipeName,
                        secondaryPipeType: this.localData.secondaryPipeType,
                    }
                    
                    this.setPipeName(temp.secondaryPipeName);
                    this.setPipeType(temp.secondaryPipeType);
                    this.setSecondaryPipeName(temp.pipeName);
                    this.setSecondaryPipeType(temp.pipeType);
                }
            }
        },
        localData: {
            handler: debounce(function(newVal, oldVal) {     
                this.$store.dispatch('submittalSystem/setSegment', this.localData);
            }, 200),
            deep: true
        },
    },
    computed: {
        ...mapState({
            "pipesLoaded": state => state.submittalPipes.loaded,
        }),
        ...mapKeyedGetters({
            "record": "submittalSystem/segment",
            "index": "submittalSystem/segmentIndex",
            "siblings": "submittalSystem/segmentSiblings"
        }),
        ...mapGetters({
            "systemMaterial": "submittalSystem/systemMaterial",
            "largestMainBranchPipeSize": "submittalSystem/largestMainBranchPipeSize",
            "mainPipeSize": "submittalSystem/mainPipeSize",
            'orientation' : 'submittalSystem/orientation',
            "pipeFromSizeAndType": "submittalPipes/pipeFromSizeAndType",
            "uniqueSizes": "submittalPipes/uniqueSizes",
            "allTypes": "submittalPipes/types"
        }),
        loadingText() {
            return !this.pipesLoaded ? 'Loading' : 'Select One';
        },
        lateralMin() {
            if (this.localData.longitudinalPipeLength === null) {
                return 0;
            }
            return Number(this.localData.longitudinalPipeLength) === 0 ? 0.001 : 0;
        },
        longitudinalMin() {
            if (this.localData.lateralPipeLength === null) {
                return 0;
            }
            return Number(this.localData.lateralPipeLength) === 0 ? 0.001 : 0;
        },
        lateralMax() {
            let max = this.lateralLimit;
            if (!this.localData.lateralPipeLength) {
                return max;
            }
            let current = Number(this.localData.lateralPipeLength);
            return max + current;
        },
        longitudinalMax() {
            let max = this.longitudinalLimit;
            if (!this.localData.longitudinalPipeLength) {
                return max;
            }
            let current = Number(this.localData.longitudinalPipeLength);
            return max + current;
        },
        types() {
            return this.getAllTypes(false);
        },
        filteredTypes() {
            return this.getAllTypes(true);
        },
        lateralPipes() {
            if (this.hasMainPipe) {
                if ('lateral-longitudinal' == this.orientation) {
                    return this.getAllPipes(false);
                }
            }
            return this.getAllPipes(true);
        },
        longitudinalPipes() {
            if (this.hasMainPipe) {
                if ('longitudinal-lateral' == this.orientation) {
                    return this.getAllPipes(false);
                }
            }
            return this.getAllPipes(true);
        },
        maxPipeSize() {
            if (this.index === 0) {
                return null;
            }

            return this.mainPipeSize;
        },
        hasMainPipe() {
            return (this.mainBranch && this.index == 0);
        },
        name() {
            if (this.mainBranch && this.index === 0) {
                return 'Main';
            }

            return ALPHA[this.index] ? ALPHA[this.index].toUpperCase() : null;
        },
        can() {
            return {
                delete: !(this.mainBranch && (this.record.riserNipple || this.index === 0))
            };
        },
        orientationError() {
            const primary = Number(this.localData.pipeSize);
            const secondary = Number(this.localData.secondaryPipeSize);

            if (secondary > primary) {
                if (this.orientation == 'longitudinal-lateral') {
                    return 'Lateral pipe size cannot exceed longitudinal pipe size';
                } else if (this.orientation == 'lateral-longitudinal') {
                    return 'Longitudinal pipe size cannot exceed lateral pipe size';
                }
            } 

            /*
            -------------------------------
            2024-12-20
            Commenting out this method logic and returning false because Charlie and John decided  
            we don't need to implement any restrictions on one direction being longer than the other. 
            
            If they change their minds again we can uncomment it. This works in conjunction with
            the hasErrors computed property on the system.vue component so if you uncomment
            this block you'll also need to uncomment the code in the other component as well.

            At some point in the future, you may delete this method and the template div that displays
            it at your discretion. If you do so, please delete the check in the hasErrors computed
            property in the system.vue component as well.
            -------------------------------

            const lateral = Number(this.localData.lateralPipeLength);
            const longitudinal = Number(this.localData.longitudinalPipeLength);
            if (this.orientation == 'longitudinal-lateral') {
                if (lateral > longitudinal) {
                    return 'Lateral length cannot exceed longitudinal length';
                }
            }
            if (this.orientation == 'lateral-longitudinal') {
                if (longitudinal > lateral) {
                    return 'Longitudinal length cannot exceed lateral length';
                }
            }
            */
            
            return false;
        },
        pipeNote() {
            let sch10Note = 'Note: Schedule 10 pipe per NFPA 13 requires a minimum wall thickness of 0.188” for 8”, 10”, and 12” NPS pipe.';
            
            if (this.localData.pipeSize >= 8 && this.localData.pipeType == 'Steel Sch 10') {
                return sch10Note;
            }
            if (this.localData.secondaryPipeSize >= 8 && this.localData.secondaryPipeType == 'Steel Sch 10') {
                return sch10Note
            }

            return '';
        },
        lateralPipeSize() {
            if (this.orientation == 'longitudinal-lateral') {
                return this.localData.secondaryPipeSize;
            }
            
            return this.localData.pipeSize;
        },
        lateralPipeType() {
            if (this.orientation == 'longitudinal-lateral') {
                return this.localData.secondaryPipeType;
            }
            
            return this.localData.pipeType;
        },
        lateralWeightPerFoot() {
            const pipe = this.pipeFromSizeAndType(this.lateralPipeSize, this.lateralPipeType);

            return (pipe) ? pipe.weight : 0;
        },
        lateralWeight() {
            return this.localData.lateralPipeLength * this.lateralWeightPerFoot;
        },
        longitudinalPipeSize() {
            if (this.orientation == 'lateral-longitudinal') {
                return this.localData.secondaryPipeSize;
            }
            
            return this.localData.pipeSize;
        },
        longitudinalPipeType() {
            if (this.orientation == 'lateral-longitudinal') {
                return this.localData.secondaryPipeType;
            }
            
            return this.localData.pipeType;
        },
        longitudinalWeightPerFoot() {
            let pipe = this.pipeFromSizeAndType(this.longitudinalPipeSize, this.longitudinalPipeType);

            return (pipe) ? pipe.weight : 0;
        },
        longitudinalWeight() {
            return this.localData.longitudinalPipeLength * this.longitudinalWeightPerFoot;
        },
        displayFirst() {
            // This horrible, hacky thing supports duplicated code so lateral and longitudinal rows can be swapped around
            // I tried to put them into slots, but I couldn't find a way to do it without adding an extra div in the child
            // component template which breaks the flex layout. If editing either row be sure to update it in both places.
            return this.orientation == 'lateral-longitudinal' ? 'lateral' : 'longitudinal';
        },
    },
    methods: {
        getAllTypes(filtered) {
            let disabled = false;
            let checkSize = (this.localData.pipeSize) ? this.localData.pipeSize : this.maxPipeSize;
            let options = [];
            let bySize = (checkSize) ? this.$store.getters['submittalPipes/typesFromSize'](checkSize) : [];

            let lineSegmentComponent = this;

            this.allTypes.forEach(function(type) {
                disabled = false;

                if (bySize.length && !bySize.includes(type)) {
                    disabled = true;
                }
                if (!lineSegmentComponent.hasMainPipe || filtered) {
                    if (!lineSegmentComponent.validPipeType(type, filtered)) {
                        disabled = true;
                    }
                }
                options.push({'type':type, 'disabled': disabled});
            });

            return options;
        },
        getAllPipes(filtered) {
            let allPipes = this.uniqueSizes;
            let validTypes = this.pipeSizesByType();

            // 3 1/2" not valid for main branch
            if (this.mainBranch) {
                validTypes = validTypes.filter(s => parseFloat(s.size) != 3.5);
            }

            // Don't show lower than size 1 in the Main,
            // Main segments and in Riser Nipple sizes
            if (this.mainBranch || this.record.riserNipple) {
                validTypes = validTypes.filter(s => parseFloat(s.size) >= 1);
            }

            // Branch segments can have a max size of 3
            if (!this.mainBranch && !this.record.riserNipple) {
                validTypes = validTypes.filter(s => parseFloat(s.size) <= 3);
            }

            // Segments can't exceed the Main
            if (!this.mainBranch || filtered || this.mainBranch && this.index !== 0 && !this.record.riserNipple) {
                validTypes = validTypes.filter(s => parseFloat(s.size) <= this.mainPipeSize);
            }

            let disabled = false;
            let options = [];
            let max = this.maxPipeSize;
            let matchType = false;

            allPipes.forEach(function(pipe){
                disabled = false;

                if (validTypes.length) {
                    matchType = validTypes.some(i => {
                        if (max && parseFloat(i.size) > max) {
                            return false; // pipe size can't exceed the max
                        }

                        return i.name == pipe.name;
                    });

                    if (!matchType) {
                        disabled = true;
                    }
                }

                options.push({'name':pipe.name, 'size':parseFloat(pipe.size), 'disabled': disabled});
            });

            return options.sort((a, b) => a.size - b.size);
        },
        pipeSizesByType() {
            if (this.localData.pipeType) {
                return this.$store.getters['submittalPipes/sizesFromType'](this.localData.pipeType);
            }

            return this.uniqueSizes;
        },
        setPipeSize(name) {
            let pipes = this.pipeSizesByType();
            let chosen = pipes.filter(i => i.name == name).map(i => parseFloat(i.size));

            this.$set(this.localData, 'pipeSize', chosen[0]);
        },
        setName($event) {
            this.setPipeName($event.target.value);
        },
        setPipeName(name) {
            this.$set(this.localData, 'pipeName', name);

            this.setPipeSize(name);
        },
        setType($event) {
            this.setPipeType($event.target.value);
        },
        setPipeType(type) {
            this.$set(this.localData, 'pipeType', type);

            this.setPipeSize(this.localData.pipeName);

            this.setMainPipeType();
        },
        setMainPipeType() {
            if (this.hasMainPipe) {
                let payload = {
                    name: this.localData.pipeName,
                    type: this.localData.pipeType
                };
                this.$store.dispatch('submittalSystem/setMainPipeType', payload);
            }
        },
        setSecondaryPipeSize(name) {
            let pipes = this.pipeSizesByType();
            let chosen = pipes.filter(i => i.name == name).map(i => parseFloat(i.size));

            this.$set(this.localData, 'secondaryPipeSize', chosen[0]);
            this.setSecondaryWeightPerFoot();
        },
        setSecondaryName($event) {
            this.setSecondaryPipeName($event.target.value);
        },
        setSecondaryPipeName(name) {
            this.$set(this.localData, 'secondaryPipeName', name);

            this.setSecondaryPipeSize(name);
        },
        setSecondaryType($event) {
            this.setSecondaryPipeType($event.target.value);
        },
        setSecondaryPipeType(name) {
            this.$set(this.localData, 'secondaryPipeType', name);

            this.setSecondaryPipeSize(this.localData.secondaryPipeName);
        },
        setSecondaryWeightPerFoot() {
            this.$set(this.localData, 'secondaryWeightPerFoot', this.secondaryWeightPerFoot);
        },
        removeSegment() {
            this.$store.dispatch('submittalSystem/removeSegment', this.localData);
        },
        getValidPipeTypes(filtered) {
            if (this.hasMainPipe && !filtered) {
                return this.allTypes;
            } else {
                return this.$store.getters['submittalPipes/typesFromMaterial'](this.systemMaterial);
            }
        },
        validPipeType(type, filtered) {
            let types = this.getValidPipeTypes(filtered);
           
            if (types.length > 0) {
                return types.includes(type);
            }

            return true;
        },
        toFrac: n => (new Fraction(n)).toFraction(true),
    }
}
</script>